import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
const PRODUCT_ID = '1012222303009777000'
const TYPE = 'Savings'
const beneficiaryType = 'DMR'

const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      code: 'SERVER_500',
      message: 'Product service is currently unavailable. Please try again later.',
    }
  }
  if (data?.data?.responseStatus?.code === '000') {
    console.log(data?.data?.responseObject, 'See what data?responseObject is (SUCCESS)')
    return data.data.responseObject
  } else if (isStatusOK(data)) {
    console.log(data?.data, 'See what data?data is')
    console.log(data?.data?.responseObject, 'See what data?responseObject is')
    return data.data.responseObject
  } else {
    console.log(data?.data, 'See what data?data is in catch')
    console.log(data, 'See what data?responseObject is in catch')
    const errorData = data?.data?.responseStatus || {
      code: 'NETWORK_ERROR',
      message: 'Request failed with unknown status structure.',
    }

    throw errorData
  }
}

export const getProductListBCApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  //   customerDetails: {
  //     jpbUserId: '1972283249505670348',
  //     agentId: 'JI01JI02AGT511317023',
  const requestBody = {
    category: {
      id: body?.categoryId,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
    },
  }
  console.log('API Request Body for getProductListBCApi:', requestBody)
  console.log('API Request Headers for getProductListBCApi:', config.headers)
  console.log('Sending x-user-access-token:', config.headers['x-user-access-token'])
  console.log('Sending x-userid-token:', config.headers['x-userid-token'])
  console.log('Sending Request Body:', requestBody)
  const request: Request<{}> = {
    apiPath: APIEndPoints.getProductList,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to respponse parse')
      console.log('FULL API DATA received in getProductListBCApi:', JSON.stringify(data))
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      const errorDetails = getNetworkResponseError(err)
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw errorDetails
      // throw err
    })
}
